<span class="address" *ngIf="!linkToGoogleMaps">
  <span>{{ address }}</span
  ><span *ngIf="address2">, {{ address2 }}</span
  ><span>, {{ city }}</span
  ><span>, {{ state ? state : "MD" }}</span> {{ zip }}
</span>

<a
  *ngIf="linkToGoogleMaps"
  [href]="googleMapsUrl"
  target="_blank"
  rel="noopener noreferrer"
  class="google-maps-link"
>
  <span class="address">
    <span>{{ address }}</span
    ><span *ngIf="address2">, {{ address2 }}</span
    ><span>, {{ city }}</span
    ><span>, {{ state ? state : "MD" }}</span> {{ zip }}
  </span>
  <i class="fa fa-external-link"></i>
</a>
